import { fetchDataFromBackend } from "../api/api";
import Employee from "../DTOs/employee";
import logger from "../core/utils/logger";

const isSimulation= import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

const simulatedEmployees = [
    Object.assign(new Employee(), {
        id: 1,
        name: "Alice",
        surname: "Miller",
        email: "alice.miller@example.com",
        password: "test123",
        role: "Admin",
        active: true,
    }),
    Object.assign(new Employee(), {
        id: 2,
        name: "Bob",
        surname: "Brown",
        email: "bob.brown@example.com",
        password: "demo456",
        role: "Employee",
        active: false,
    })
];

export const EmployeeService = {
    async getEmployees() {
        try {
            
            // Simulate data fetching from backend
            if (isSimulation) {
                logger.log("Simulation mode enabled. Returning simulated data.");
                return simulatedEmployees;
            }
            const employees = await fetchDataFromBackend("/employees");
            return employees.map((employee) => Object.assign(new Employee(), employee));
        }
        catch (error) {
            logger.error("Error fetching employees:", error);
            throw error;
        }
    }
};